import React from 'react';
import { CloseIcon, CheckIcon } from '../../CustomIcons.js';
import { If } from '../../If/index.js';

const ValidationIcon = ({ isValid }) => {
  return (
    <React.Fragment>
      <If test={isValid}>
        <CheckIcon />
      </If>

      <If test={!isValid}>
        <CloseIcon />
      </If>
    </React.Fragment>
  );
};

export { ValidationIcon };
